import { render, staticRenderFns } from "./truck-loads.html?vue&type=template&id=184ab6cc&scoped=true&"
import script from "./truck-loads.ts?vue&type=script&lang=js&"
export * from "./truck-loads.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184ab6cc",
  null
  
)

export default component.exports